<template>
  <w-icon-wrapper
    :height='24'
    :width='19.2'
    icon-name='work-camera-icon'
    view-box='0 0 24 19.2'
  >
    <path
      id="Pfad_55840"
      data-name="Pfad 55840"
      d="M18.18,5,16.62,1.8H9.4L7.7,5H0V21H24V5ZM22,19H2V7H8.89L10.6,3.8h4.78L16.93,7H22Z"
      transform="translate(0 -1.8)"
      fill="currentColor"
    />
    <path
      id="Pfad_55841"
      data-name="Pfad 55841"
      d="M13,7.8a5,5,0,1,0,5,5,5,5,0,0,0-5-5Zm0,8a3,3,0,1,1,3-3,3,3,0,0,1-3,3Z"
      transform="translate(0 -1.8)"
      fill="currentColor"
    />
    <rect
      id="Rechteck_4045"
      data-name="Rechteck 4045"
      width="4"
      height="2"
      transform="translate(2)"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconDocumentCamera' };
</script>
